import React from "react";

export function Card({ className, variant = "default", isGlass = false, ...props }) {
  const baseClasses = "rounded-xl border shadow-sm transition-all duration-300";
  
  const variantClasses = {
    default: "bg-white text-gray-900",
    primary: "bg-primary-50 border-primary-200 text-primary-900",
    secondary: "bg-secondary-50 border-secondary-200 text-secondary-900",
    gradient: "bg-gradient-to-br from-primary-50 via-white to-secondary-50 text-gray-900",
  };
  
  const glassClasses = isGlass ? 
    "backdrop-blur-md bg-white/70 border-white/20 shadow-glass hover:shadow-glass-hover" : "";
  
  return (
    <div
      className={`${baseClasses} ${variantClasses[variant] || ""} ${glassClasses} ${className || ""} hover:shadow-card-hover`}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }) {
  return (
    <div
      className={`flex flex-col space-y-1.5 p-6 ${className || ""}`}
      {...props}
    />
  );
}

export function CardTitle({ className, ...props }) {
  return (
    <h3
      className={`text-2xl font-semibold leading-none tracking-tight ${className || ""}`}
      {...props}
    />
  );
}

export function CardDescription({ className, ...props }) {
  return (
    <p
      className={`text-sm text-gray-500 dark:text-gray-400 ${className || ""}`}
      {...props}
    />
  );
}

export function CardContent({ className, ...props }) {
  return (
    <div className={`p-6 pt-0 ${className || ""}`} {...props} />
  );
}

export function CardFooter({ className, ...props }) {
  return (
    <div
      className={`flex items-center p-6 pt-0 ${className || ""}`}
      {...props}
    />
  );
}
